// LanguageSelector.tsx
import React, { useState, useRef, useEffect } from "react";
import { useTranslation } from "react-i18next";
import colors from "../../styles/colors";

const LanguageSelector: React.FC = () => {
  const { i18n } = useTranslation();
  const [languageDropdown, setLanguageDropdown] = useState(false);
  const [isHoveredLanguage, setIsHoveredLanguage] = useState(false);
  const languageDropdownRef = useRef<HTMLDivElement>(null);

  const handleLanguageChange = (lang: string) => {
    i18n.changeLanguage(lang); // Nyelv váltása
    setLanguageDropdown(false); // Legördülő menü bezárása
  };

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        languageDropdownRef.current &&
        !languageDropdownRef.current.contains(event.target as Node)
      ) {
        setLanguageDropdown(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={languageDropdownRef}>
      <div
        onClick={() => setLanguageDropdown(!languageDropdown)}
        className="w-9 h-9 flex items-center justify-center rounded-full cursor-pointer font-normal transition-colors duration-300 hover:bg-gray-200"
        style={{
          backgroundColor: isHoveredLanguage
            ? colors.primaryGreen
            : colors.lightCream,
          color: isHoveredLanguage ? colors.lightCream : colors.black,
        }}
        onMouseEnter={() => setIsHoveredLanguage(true)}
        onMouseLeave={() => setIsHoveredLanguage(false)}
      >
        {i18n.language.toUpperCase()}
      </div>

      {languageDropdown && (
        <div
          className="absolute left-1/2 transform -translate-x-1/2 mt-2 w-16 rounded-md shadow-lg"
          style={{ backgroundColor: colors.lightCream }}
        >
          {["ro", "en", "hu"].map((lang) => (
            <div
              key={lang}
              onClick={() => handleLanguageChange(lang)}
              className={`cursor-pointer px-4 py-2 text-center transition-all duration-300 ${
                i18n.language === lang
                  ? "font-thin text-white"
                  : "text-gray-900 hover:text-gray-400"
              }`}
              style={{
                backgroundColor:
                  i18n.language === lang ? colors.primaryGreen : "transparent",
                borderRadius: i18n.language === lang ? "6px" : "0px", // Itt állítja be a lekerekítést
              }}
            >
              {lang.toUpperCase()}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default LanguageSelector;
